"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserServiceContractMeetingChargeMetaModel = void 0;
var abstract_billing_meta_1 = require("./abstract-billing-meta");
var billing_meta_model_enum_1 = require("./billing-meta-model-enum");
/** Начисление за митинг по контракту на услугу преподавателей */
var UserServiceContractMeetingChargeMetaModel = /** @class */function (_super) {
  __extends(UserServiceContractMeetingChargeMetaModel, _super);
  function UserServiceContractMeetingChargeMetaModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.model = billing_meta_model_enum_1.BillingMetaModelEnum.user_service_contract_meeting_charge;
    return _this;
  }
  UserServiceContractMeetingChargeMetaModel.prototype.getClassProperties = function () {
    return __spreadArray(__spreadArray([], _super.prototype.getClassProperties.call(this), true), ['account_id', 'user_service_id', 'user_service_contract_id', 'user_service_contract_order_id', 'meeting_id', 'meeting_participant_id'], false);
  };
  return UserServiceContractMeetingChargeMetaModel;
}(abstract_billing_meta_1.AbstractBillingMeta);
exports.UserServiceContractMeetingChargeMetaModel = UserServiceContractMeetingChargeMetaModel;
